//Styles
import '../sass/main.scss';
//Libs
import { loadSwiperHandlers } from './libs/Swiper';
//Layout
import { loadHeaderHandlers } from './layout/Header';
import { Page404 } from './layout/Page404';
import { History } from './layout/History';
//Api
import { loadEndpointTimeHandlers } from './api/Time';
import { loadAuthHandlers } from './api/Auth';
import { loadTriviaHandlers } from './api/Trivia';
import { loadRankingHandlers } from './api/Ranking';
import { loadTriviaTestHandlers } from './api/Trivia-test';
//Components
import { loadToggleHandlers } from './components/Toggle';
import { loadPasswordHandlers } from './components/Password';
import { TriviaWinner } from './components/TriviaWinner';
import { SoundButton, SoundStadium, SoundStop, SoundWinner } from './components/Sounds';
import { TriviaDisableButtons } from './components/TriviaDisableButtons';


window.addEventListener('load', ()=>{
    loadHeaderHandlers();
    loadSwiperHandlers();
    loadEndpointTimeHandlers();
    loadToggleHandlers();
    loadPasswordHandlers();
    loadAuthHandlers();
    if(document.querySelector('#trivia-resume')){
        loadTriviaHandlers();
    }
    if(document.querySelector('#trivia-winner')){
        TriviaWinner();
    }
    if(document.querySelector('#ranking')){
        loadRankingHandlers();
    }
    if(document.querySelector('#trivia-pages')){
        SoundStadium();
        SoundStop();
    }
    if(document.querySelector('#trivia-test')){
        loadTriviaTestHandlers();
    }
    SoundButton();
    TriviaDisableButtons();
    SoundWinner();
    History();
});

window.addEventListener('DOMContentLoaded', ()=>{
    Page404();
});